import { render, staticRenderFns } from "./TrainAmenitiesLayout.vue?vue&type=template&id=8b8c51e8"
import script from "./TrainAmenitiesLayout.vue?vue&type=script&lang=js"
export * from "./TrainAmenitiesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports